/**
 * North Curtain — Geo Store Redirect
 * Detects visitor country via Cloudflare Worker and shows a store-switch modal.
 */
(function () {
  'use strict';

  var CFG = window.__geoRedirectConfig;
  if (!CFG || !CFG.enabled || CFG.mode === 'disabled' || !CFG.workerUrl) return;

  // ── Whitelist ──────────────────────────────────────────────────────────────
  var CA_HOST = stripProtocol(CFG.caUrl);
  var US_HOST = stripProtocol(CFG.usUrl);
  var ALLOWED_HOSTS = [CA_HOST, US_HOST];

  var CURRENT_HOST = stripProtocol(CFG.currentHost);
  var CURRENT_STORE =
    CURRENT_HOST === CA_HOST ? 'ca' :
    CURRENT_HOST === US_HOST ? 'us' :
    null;

  // ── Storage keys ───────────────────────────────────────────────────────────
  var PREF_KEY    = 'northCurtainStorePref';
  var PREF_TS_KEY = 'northCurtainStorePrefTs';

  // ── Helpers ────────────────────────────────────────────────────────────────
  function log() {
    if (CFG.debug) {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[GeoRedirect]');
      console.log.apply(console, args);
    }
  }

  function stripProtocol(url) {
    return (url || '').replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/$/, '');
  }

  function isBot() {
    return /bot|crawl|spider|slurp|mediapartners|googlebot|bingbot|yandex|baidu|duckduck|facebot|ia_archiver|pingdom|uptimerobot|semrush|ahrefsbot|mj12bot/i
      .test(navigator.userAgent);
  }

  function isThemeEditor() {
    return (window.Shopify && window.Shopify.designMode === true) ||
      window.location.search.indexOf('preview_theme_id=') !== -1 ||
      window.location.search.indexOf('_fd=0') !== -1;
  }

  function isRestrictedPage() {
    var path = window.location.pathname;
    return /^\/(checkout|cart|a\/logout|account)(\/|$)/i.test(path);
  }

  // ── Safe redirect URL builder ──────────────────────────────────────────────
  function buildRedirectUrl(targetBase, path, search, hash) {
    var targetHost = stripProtocol(targetBase);
    if (ALLOWED_HOSTS.indexOf(targetHost) === -1) {
      log('Blocked redirect to non-whitelisted host:', targetHost);
      return null;
    }
    var params = new URLSearchParams(search);
    params.delete('store_override');
    var qs = params.toString() ? '?' + params.toString() : '';
    return targetBase.replace(/\/$/, '') + path + qs + hash;
  }

  // ── Preference storage (localStorage with cookie fallback) ─────────────────
  function savePreference(value) {
    try {
      localStorage.setItem(PREF_KEY, value);
      localStorage.setItem(PREF_TS_KEY, Date.now().toString());
    } catch (e) {
      var days = CFG.expiryDays || 30;
      document.cookie = PREF_KEY + '=' + value +
        '; path=/; max-age=' + (days * 86400) + '; SameSite=Lax';
    }
    log('Saved preference:', value);
  }

  function getPreference() {
    try {
      var val = localStorage.getItem(PREF_KEY);
      var ts  = parseInt(localStorage.getItem(PREF_TS_KEY) || '0', 10);
      if (!val) return null;
      var expiry = (CFG.expiryDays || 30) * 86400 * 1000;
      if (Date.now() - ts > expiry) {
        localStorage.removeItem(PREF_KEY);
        localStorage.removeItem(PREF_TS_KEY);
        return null;
      }
      return val;
    } catch (e) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + PREF_KEY + '=([^;]*)'));
      return m ? m[1] : null;
    }
  }

  // ── Handle ?store_override= param ─────────────────────────────────────────
  function handleStoreOverride() {
    var params = new URLSearchParams(window.location.search);
    var override = params.get('store_override');
    if (!override) return false;
    log('store_override param:', override);
    if (override === 'ca' || override === 'us') {
      savePreference(override);
    }
    // Remove param from URL to keep canonical clean
    params.delete('store_override');
    var qs = params.toString() ? '?' + params.toString() : '';
    var newUrl = window.location.pathname + qs + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    return true;
  }

  // ── Modal ──────────────────────────────────────────────────────────────────
  function showModal(targetStore, redirectUrl) {
    var modal = document.getElementById('geo-redirect-modal');
    if (!modal) return;

    var msg = CFG.messages[targetStore];
    document.getElementById('geo-modal-heading').textContent = msg.heading;
    document.getElementById('geo-modal-desc').textContent    = msg.desc;

    var goBtn   = modal.querySelector('[data-geo-go]');
    var stayBtn = modal.querySelector('[data-geo-stay]');

    goBtn.textContent = msg.go;
    goBtn.href        = redirectUrl;
    stayBtn.textContent = msg.stay;

    modal.hidden = false;
    document.body.classList.add('geo-modal-open');
    goBtn.focus();

    function dismiss(storeChoice) {
      savePreference(storeChoice);
      hideModal();
    }

    goBtn.addEventListener('click', function () {
      dismiss(targetStore);
    }, { once: true });

    stayBtn.addEventListener('click', function () {
      dismiss(CURRENT_STORE);
    }, { once: true });

    modal.querySelector('[data-geo-close]').addEventListener('click', function () {
      dismiss(CURRENT_STORE);
    }, { once: true });

    modal.querySelector('[data-geo-overlay]').addEventListener('click', function () {
      dismiss(CURRENT_STORE);
    }, { once: true });

    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        dismiss(CURRENT_STORE);
        document.removeEventListener('keydown', escHandler);
      }
    });

    modal.addEventListener('keydown', trapFocus);
  }

  function hideModal() {
    var modal = document.getElementById('geo-redirect-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('geo-modal-open');
    modal.removeEventListener('keydown', trapFocus);
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var modal = document.getElementById('geo-redirect-modal');
    var els = modal.querySelectorAll('a[href], button:not([disabled])');
    var first = els[0];
    var last  = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  // ── GeoIP via <script> tag ────────────────────────────────────────────────
  // The Liquid snippet injects <script src="WORKER_URL?jsonp=1"> which sets
  // window.__ncCountry and window.__ncCountryLoaded — no CORS needed.
  function fetchCountry() {
    return new Promise(function (resolve) {
      if (window.__ncCountryLoaded) {
        return resolve(window.__ncCountry || 'XX');
      }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (window.__ncCountryLoaded) {
          clearInterval(poll);
          resolve(window.__ncCountry || 'XX');
        } else if (attempts >= 40) { // 40 × 100 ms = 4 s timeout
          clearInterval(poll);
          resolve('XX');
        }
      }, 100);
    });
  }

  // ── Main ───────────────────────────────────────────────────────────────────
  function init() {
    if (!CURRENT_STORE)    { log('Unknown store, skipping'); return; }
    if (isBot())           { log('Bot detected, skipping'); return; }
    if (isThemeEditor())   { log('Theme editor, skipping'); return; }
    if (isRestrictedPage()) { log('Restricted page, skipping'); return; }

    // Handle ?store_override= first (returns true if override was present)
    var hadOverride = handleStoreOverride();

    var pref = getPreference();
    log('Store:', CURRENT_STORE, '| Pref:', pref, '| Override:', hadOverride);

    // If user explicitly prefers this store, do nothing
    if (pref === CURRENT_STORE) { log('User prefers this store'); return; }

    // If override just set preference to other store but we're still here,
    // the redirect will happen naturally (the link the user clicked goes there).
    // If override set preference to current store, do nothing.
    if (hadOverride) { log('Override handled, no additional action'); return; }

    fetchCountry().then(function (country) {
      log('Country:', country);

      // Determine if a redirect is warranted
      var targetStore = null;
      if (country === 'CA' && CURRENT_STORE === 'us') targetStore = 'ca';
      if (country === 'US' && CURRENT_STORE === 'ca') targetStore = 'us';

      if (!targetStore) { log('No redirect needed'); return; }

      // User already explicitly chose the *other* store — respect it
      if (pref && pref !== CURRENT_STORE) { log('User chose other store previously'); return; }

      var targetBase = targetStore === 'ca' ? CFG.caUrl : CFG.usUrl;
      var redirectUrl = buildRedirectUrl(
        targetBase,
        window.location.pathname,
        window.location.search,
        window.location.hash
      );
      if (!redirectUrl) return;

      log('Redirect target:', redirectUrl, '| Mode:', CFG.mode);

      if (CFG.mode === 'automatic') {
        savePreference(targetStore);
        window.location.replace(redirectUrl);
      } else {
        showModal(targetStore, redirectUrl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
